import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1264f8a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "encabezado" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Instituto Avanzado de Artroscopía y Artroplastía"),
  /*#__PURE__*/_createElementVNode("h4", null, " Dr. Carlos Morales Ángeles | Ortopedia, Traumatología y Artroscopía "),
  /*#__PURE__*/_createElementVNode("h6", null, "Tel.: (809) 770-9215 ♦ E-Mail: dr.moralesangeles@gmail.com")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Empleado No.: ", -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Referido Por: ", -1))
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha / Hora: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Paciente")
], -1))
const _hoisted_12 = { class: "grid-2" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Nombre y Apellido: ", -1))
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha de Nacimiento: ", -1))
const _hoisted_17 = { class: "field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Edad: ", -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Sexo: ", -1))
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cédula: ", -1))
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Teléfono: ", -1))
const _hoisted_25 = { class: "field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Dirección: ", -1))
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Seguro: ", -1))
const _hoisted_29 = { class: "field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Oficio: ", -1))
const _hoisted_31 = { class: "field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Deporte: ", -1))
const _hoisted_33 = { class: "field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Lado Dominante: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "APP y Hábitos Tóxicos")
], -1))
const _hoisted_36 = { class: "grid-2" }
const _hoisted_37 = { class: "field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "APP: ", -1))
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Hábitos Tóxicos: ", -1))
const _hoisted_41 = { class: "field" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Antecedentes Quirúrgicos: ", -1))
const _hoisted_43 = { class: "field" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Alergias : ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Exámen Físico")
], -1))
const _hoisted_46 = { class: "grid-2" }
const _hoisted_47 = { class: "field" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Mecanismo de la Lesión: ", -1))
const _hoisted_49 = { class: "field" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Tiempo de Evolución: ", -1))
const _hoisted_51 = { class: "field" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Elevación Anterior (Activa): ", -1))
const _hoisted_53 = { class: "field" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Elevación Anterior (Pasiva): ", -1))
const _hoisted_55 = { class: "field" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Rotación Interna: ", -1))
const _hoisted_57 = { class: "field" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Rotación Externa: ", -1))
const _hoisted_59 = { class: "field" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ABD: ", -1))
const _hoisted_61 = { class: "field" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "JOBE: ", -1))
const _hoisted_63 = { class: "field" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "SPEED: ", -1))
const _hoisted_65 = { class: "field" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "OBRIEN: ", -1))
const _hoisted_67 = { class: "field" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NAPONEON: ", -1))
const _hoisted_69 = { class: "field" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Acromio Clavicular: ", -1))
const _hoisted_71 = { class: "field" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Inestabilidad Anterior: ", -1))
const _hoisted_73 = { class: "field" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Inestabilidad Posterior: ", -1))
const _hoisted_75 = { class: "field" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cajón Anterior: ", -1))
const _hoisted_77 = { class: "field" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cajón Posterior: ", -1))
const _hoisted_79 = { class: "field" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "LACHMAN: ", -1))
const _hoisted_81 = { class: "field" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "APPLEY: ", -1))
const _hoisted_83 = { class: "field" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Bostezo Lateral: ", -1))
const _hoisted_85 = { class: "field" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Bostezo Medial: ", -1))
const _hoisted_87 = { class: "field" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Otra Lesión: ", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Estudios Solicitados")
], -1))
const _hoisted_90 = { class: "grid-2" }
const _hoisted_91 = { class: "field" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Estudios Solicitados: ", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Diagnósticos")
], -1))
const _hoisted_94 = { class: "grid-2" }
const _hoisted_95 = { class: "field" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Diagnóstico Presuntivo: ", -1))
const _hoisted_97 = { class: "field" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Diagnóstico Por Imagen: ", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Tratamiento Efectuado")
], -1))
const _hoisted_100 = { class: "grid-2" }
const _hoisted_101 = { class: "field" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Medicamentos: ", -1))
const _hoisted_103 = { class: "field" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Terapia Física: ", -1))
const _hoisted_105 = { class: "field" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cirugía: ", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Consultas")
], -1))
const _hoisted_108 = { class: "grid" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "field" }, " _______________________________________ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", { class: "field bold" }, " Dr. Carlos Morales Ángeles "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", { class: "field bold" }, " Exq. 473-10 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(_ctx.formatSecuence(_ctx.empleado.no)), 1)
        ]),
        _createElementVNode("p", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_ctx.empleado.referidoPor), 1)
        ]),
        _createElementVNode("p", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.empleado.fechaActual)), 1)
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, [
          _hoisted_14,
          _createTextVNode(_toDisplayString(_ctx.empleado.nombre), 1)
        ]),
        _createElementVNode("p", _hoisted_15, [
          _hoisted_16,
          _createTextVNode(_toDisplayString(_ctx.formatDate2(_ctx.empleado.fechaNacimiento)), 1)
        ]),
        _createElementVNode("p", _hoisted_17, [
          _hoisted_18,
          _createTextVNode(_toDisplayString(_ctx.empleado.edad) + " Años ", 1)
        ]),
        _createElementVNode("p", _hoisted_19, [
          _hoisted_20,
          _createTextVNode(_toDisplayString(_ctx.empleado.sexo), 1)
        ]),
        _createElementVNode("p", _hoisted_21, [
          _hoisted_22,
          _createTextVNode(_toDisplayString(_ctx.empleado.cedula), 1)
        ]),
        _createElementVNode("p", _hoisted_23, [
          _hoisted_24,
          _createTextVNode(_toDisplayString(_ctx.empleado.telefono), 1)
        ]),
        _createElementVNode("p", _hoisted_25, [
          _hoisted_26,
          _createTextVNode(_toDisplayString(_ctx.empleado.direccion), 1)
        ]),
        _createElementVNode("p", _hoisted_27, [
          _hoisted_28,
          _createTextVNode(_toDisplayString(_ctx.empleado.seguro), 1)
        ]),
        _createElementVNode("p", _hoisted_29, [
          _hoisted_30,
          _createTextVNode(_toDisplayString(_ctx.empleado.oficio), 1)
        ]),
        _createElementVNode("p", _hoisted_31, [
          _hoisted_32,
          _createTextVNode(_toDisplayString(_ctx.empleado.deporte), 1)
        ]),
        _createElementVNode("p", _hoisted_33, [
          _hoisted_34,
          _createTextVNode(_toDisplayString(_ctx.empleado.ladoDominante), 1)
        ])
      ]),
      _hoisted_35,
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("p", _hoisted_37, [
          _hoisted_38,
          _createTextVNode(_toDisplayString(_ctx.empleado.app), 1)
        ]),
        _createElementVNode("p", _hoisted_39, [
          _hoisted_40,
          _createTextVNode(_toDisplayString(_ctx.empleado.habitosToxicos), 1)
        ]),
        _createElementVNode("p", _hoisted_41, [
          _hoisted_42,
          _createTextVNode(_toDisplayString(_ctx.empleado.antQuirurgicos), 1)
        ]),
        _createElementVNode("p", _hoisted_43, [
          _hoisted_44,
          _createTextVNode(_toDisplayString(_ctx.empleado.alergias), 1)
        ])
      ]),
      _hoisted_45,
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("p", _hoisted_47, [
          _hoisted_48,
          _createTextVNode(_toDisplayString(_ctx.empleado.mecanismoLesion), 1)
        ]),
        _createElementVNode("p", _hoisted_49, [
          _hoisted_50,
          _createTextVNode(_toDisplayString(_ctx.empleado.tiempoEvolucion), 1)
        ]),
        _createElementVNode("p", _hoisted_51, [
          _hoisted_52,
          _createTextVNode(_toDisplayString(_ctx.empleado.elevacionAnteriorActiva), 1)
        ]),
        _createElementVNode("p", _hoisted_53, [
          _hoisted_54,
          _createTextVNode(_toDisplayString(_ctx.empleado.elevacionAnteriosPasiva), 1)
        ]),
        _createElementVNode("p", _hoisted_55, [
          _hoisted_56,
          _createTextVNode(_toDisplayString(_ctx.empleado.rotacionInterna), 1)
        ]),
        _createElementVNode("p", _hoisted_57, [
          _hoisted_58,
          _createTextVNode(_toDisplayString(_ctx.empleado.rotacionExterna), 1)
        ]),
        _createElementVNode("p", _hoisted_59, [
          _hoisted_60,
          _createTextVNode(_toDisplayString(_ctx.empleado.abd), 1)
        ]),
        _createElementVNode("p", _hoisted_61, [
          _hoisted_62,
          _createTextVNode(_toDisplayString(_ctx.empleado.jobe), 1)
        ]),
        _createElementVNode("p", _hoisted_63, [
          _hoisted_64,
          _createTextVNode(_toDisplayString(_ctx.empleado.speed), 1)
        ]),
        _createElementVNode("p", _hoisted_65, [
          _hoisted_66,
          _createTextVNode(_toDisplayString(_ctx.empleado.obrien), 1)
        ]),
        _createElementVNode("p", _hoisted_67, [
          _hoisted_68,
          _createTextVNode(_toDisplayString(_ctx.empleado.naponeon), 1)
        ]),
        _createElementVNode("p", _hoisted_69, [
          _hoisted_70,
          _createTextVNode(_toDisplayString(_ctx.empleado.acromioClavicular), 1)
        ]),
        _createElementVNode("p", _hoisted_71, [
          _hoisted_72,
          _createTextVNode(_toDisplayString(_ctx.empleado.inestabilidadAnterior), 1)
        ]),
        _createElementVNode("p", _hoisted_73, [
          _hoisted_74,
          _createTextVNode(_toDisplayString(_ctx.empleado.inestabilidadPosterior), 1)
        ]),
        _createElementVNode("p", _hoisted_75, [
          _hoisted_76,
          _createTextVNode(_toDisplayString(_ctx.empleado.cajonAnterior), 1)
        ]),
        _createElementVNode("p", _hoisted_77, [
          _hoisted_78,
          _createTextVNode(_toDisplayString(_ctx.empleado.cajonPosterior), 1)
        ]),
        _createElementVNode("p", _hoisted_79, [
          _hoisted_80,
          _createTextVNode(_toDisplayString(_ctx.empleado.lachman), 1)
        ]),
        _createElementVNode("p", _hoisted_81, [
          _hoisted_82,
          _createTextVNode(_toDisplayString(_ctx.empleado.appley), 1)
        ]),
        _createElementVNode("p", _hoisted_83, [
          _hoisted_84,
          _createTextVNode(_toDisplayString(_ctx.empleado.bostezoLateral), 1)
        ]),
        _createElementVNode("p", _hoisted_85, [
          _hoisted_86,
          _createTextVNode(_toDisplayString(_ctx.empleado.bostezoMedial), 1)
        ]),
        _createElementVNode("p", _hoisted_87, [
          _hoisted_88,
          _createTextVNode(_toDisplayString(_ctx.empleado.otraLesion), 1)
        ])
      ]),
      _hoisted_89,
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("p", _hoisted_91, [
          _hoisted_92,
          _createTextVNode(_toDisplayString(_ctx.empleado.estudiosSolicitados), 1)
        ])
      ]),
      _hoisted_93,
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("p", _hoisted_95, [
          _hoisted_96,
          _createTextVNode(_toDisplayString(_ctx.empleado.diagnosticoPresuntivo), 1)
        ]),
        _createElementVNode("p", _hoisted_97, [
          _hoisted_98,
          _createTextVNode(_toDisplayString(_ctx.empleado.diagnosticoImagen), 1)
        ])
      ]),
      _hoisted_99,
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("p", _hoisted_101, [
          _hoisted_102,
          _createTextVNode(_toDisplayString(_ctx.empleado.medicamentos), 1)
        ]),
        _createElementVNode("p", _hoisted_103, [
          _hoisted_104,
          _createTextVNode(_toDisplayString(_ctx.empleado.terapiaFisica), 1)
        ]),
        _createElementVNode("p", _hoisted_105, [
          _hoisted_106,
          _createTextVNode(_toDisplayString(_ctx.empleado.cirugia), 1)
        ])
      ]),
      _hoisted_107,
      _createElementVNode("div", _hoisted_108, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empleado.consultas, (consulta, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "field",
            key: index
          }, [
            _createTextVNode(" No. " + _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.formatDate(consulta.date)), 1),
            _hoisted_109,
            _createTextVNode(" " + _toDisplayString(consulta.description), 1)
          ]))
        }), 128))
      ]),
      _hoisted_110,
      _hoisted_111,
      _hoisted_112,
      _hoisted_113,
      _hoisted_114
    ])
  ]))
}